import { Injectable, Inject } from '@angular/core';
import { AppConfigModel } from '@core/models';
import { CardType } from '@core/modules/api/models';
import { PositionService } from '@core/services/position/position.service';
import { TimeInvoking } from '@core/utils';

@Injectable({
  providedIn: 'root'
})
export class ProcessAdjusterService {
  private adjustedWith: CardType;

  private timeInvoking = new TimeInvoking();

  constructor(
    @Inject('APP_CONFIG') private appConfig: AppConfigModel,
    private positionService: PositionService
  ) {}

  init(): void {
    this.timeInvoking.invokeOnce('init', () => {
      this.positionService
        .getPositionWhenChange({ whenExists: true })
        .subscribe(res => this.adjust(res.data.cardType));
    });
  }

  private adjust(cardType: CardType): void {
    if (this.isAlreadyAdjusted(cardType)) {
      return;
    }

    this.updateAdjustedWith(cardType);

    this.adjustWizardConfig();
  }

  private isAlreadyAdjusted(cardType: CardType): boolean {
    return cardType === this.adjustedWith;
  }

  private updateAdjustedWith(cardType: CardType): void {
    this.adjustedWith = cardType;
  }

  private adjustWizardConfig(): void {
    if (this.adjustedWith === 'PREPAID') {
      this.appConfig.wizard.stopAllowedOn = [
        ['PRIMARY_DATA'],
        ['RESIDENCE_ADDRESS'],
        ['CHECK_INFO_IDENT'],
        ['CARD_CONFIRM']
      ];
    } else if (this.adjustedWith === 'CREDIT') {
      this.appConfig.wizard.stopAllowedOn = [['CARD_CONFIRM']];
    } else {
      this.appConfig.wizard.stopAllowedOn = [['']];
    }
  }
}
